export default "__VITE_ASSET__26cf487e__"